import React from 'react';

import PageWithFullHeader from './PageWithFullHeader';
import { PaymentNotification } from '../ui';

const PageWithFullHeaderAndFailedPaymentNotification = ({ children }) => {
  return (
    <PageWithFullHeader>
      <PaymentNotification />
      <main>{children}</main>
    </PageWithFullHeader>
  );
};

export default PageWithFullHeaderAndFailedPaymentNotification;
